export default __webpack_public_path__ + "static/media/umg.c8ee3f99.svg";